/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_Selected_UppercaseInputs */

const en_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events selected to convert to uppercase.`)
};

const fr_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement sélectionné pour la conversion en majuscules.`)
};

const de_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Ereignisse ausgewählt, die in Großbuchstaben umgewandelt werden sollen.`)
};

const it_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato da convertire in maiuscolo.`)
};

const ru_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для преобразования в верхний регистр не выбрано ни одного события.`)
};

const es_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay eventos seleccionados para convertir a mayúsculas.`)
};

const zh_cn2_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有选择要转换为大写的事件。`)
};

const ja_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字に変換するイベントが選択されていません。`)
};

const hi_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपरकेस में बदलने के लिए कोई इवेंट चयनित नहीं हैं।`)
};

const pt_pt2_no_events_selected_uppercase = /** @type {(inputs: No_Events_Selected_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado para conversão para maiúsculas.`)
};

/**
* | output |
* | --- |
* | "No events selected to convert to uppercase." |
*
* @param {No_Events_Selected_UppercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_events_selected_uppercase = /** @type {((inputs?: No_Events_Selected_UppercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_Selected_UppercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_events_selected_uppercase(inputs)
	if (locale === "de") return de_no_events_selected_uppercase(inputs)
	if (locale === "it") return it_no_events_selected_uppercase(inputs)
	if (locale === "ru") return ru_no_events_selected_uppercase(inputs)
	if (locale === "es") return es_no_events_selected_uppercase(inputs)
	if (locale === "zh-CN") return zh_cn2_no_events_selected_uppercase(inputs)
	if (locale === "ja") return ja_no_events_selected_uppercase(inputs)
	if (locale === "hi") return hi_no_events_selected_uppercase(inputs)
	if (locale === "pt-PT") return pt_pt2_no_events_selected_uppercase(inputs)
	return en_no_events_selected_uppercase(inputs)
});